// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CourseController from "./course_controller"
application.register("course", CourseController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import QuestionTypeController from "./question_type_controller"
application.register("question-type", QuestionTypeController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ToggleFieldController from "./toggle_field_controller"
application.register("toggle-field", ToggleFieldController)
